module.exports = __webpack_public_path__ + "static/media/mstile-310x150.61064c12.png";